import {
  Box,
  Button,
  Divider,
  makeStyles,
} from "@material-ui/core";
import { observer } from "mobx-react";
import { RangeField } from "../rangeField";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    width: "400px"
  },
  applyButton: {
    width: "300px"
  }
}));

interface RangeFiltersProps {
  label: string;
  fieldName: string;
  onApply: () => void;
}

export const RangeFilters = observer(({ label, fieldName, onApply }: RangeFiltersProps) => {
  const classes = useStyles();

  return (
    <Box display="flex" flexDirection="column" gridGap="1rem" className={classes.root}>
      <RangeField label={label} fieldName={fieldName} />
      <Divider variant="fullWidth" />
      <Box display="flex" justifyContent="center">
        <Button color="primary" variant="outlined" className={classes.applyButton} onClick={() => onApply && onApply()}>Apply</Button>
      </Box>
    </Box>
  );
});